<ul id="createNewMenu" class="newMenu inlineList">
  <li role="none" routerLinkActive="active" class="hasSubMenu header-createNew" [ngClass]="{'menuOpen':menuOpen}">
    <button
      role="menuitem"
      (click)="toggleMenuOpen($event)"
      (keydown.enter)="toggleMenuOpen($event)"
      aria-haspopup="true"
      [attr.aria-expanded]="menuOpen"
      aria-controls="dropdown-button"
      tabindex="0"
      >
      Create New
    </button>
    @if (menuOpen) {
      <ul class="submenu inlineList" id="createNewSubMenu" aria-label="Create New">
        <li [ngClass]="{'inactiveMenuItem': !canShowMenu.hasMenuAssessment}">
          @if (canShowMenu.hasMenuAssessment) {
            <a routerLink="/assessment/create-new/step1degreeplan"
              [queryParams]="{isDegreePlan: true}"
              >
              Degree Plan
            </a>
          }
          @if (!canShowMenu.hasMenuAssessment) {
            <span class="noLink" aria-label="Create a new Assessment Plan - You do not have access to this page"
              >
              Degree Plan
            </span>
          }
        </li>
        <li [ngClass]="{'inactiveMenuItem': !canShowMenu.hasMenuAssessment}">
          @if (canShowMenu.hasMenuAssessment) {
            <a routerLink="/assessment/create-new/step1administrativeplan"
              [queryParams]="{isAdministrativePlan: true}"
              >
              Administrative Plan
            </a>
          }
          @if (!canShowMenu.hasMenuAssessment) {
            <span class="noLink" aria-label="Create a new Assessment Plan - You do not have access to this page"
              >
              Administrative Plan
            </span>
          }
        </li>
        <li [ngClass]="{'inactiveMenuItem': !canShowMenu.hasMenuAssessment}">
          @if (canShowMenu.hasMenuAssessment) {
            <a routerLink="/assessment/create-new"
              [queryParams]="{isStrategicPlan: true}"
              >
              Strategic Plan
            </a>
          }
          @if (!canShowMenu.hasMenuAssessment) {
            <span class="noLink" aria-label="Create a new Assessment Plan - You do not have access to this page"
              >
              Strategic Plan
            </span>
          }
        </li>
        <!--
        <li [ngClass]="{'inactiveMenuItem': !canShowMenu.hasMenuLearningAssessment}">
          <a uiSref="la-newAssignment"
            *ngIf="canShowMenu.hasMenuLearningAssessment"
            >
            Assignment
          </a>
          <span class="noLink" aria-label="Create a new Assignment - You do not have access to this page"
            *ngIf="!canShowMenu.hasMenuLearningAssessment">
            Assignment
          </span>
        </li>
        <li [ngClass]="{'inactiveMenuItem': !canShowMenu.hasMenuLearningAssessment}">
          <a uiSref="la-libraryManageCourseState"
            *ngIf="canShowMenu.hasMenuLearningAssessment"
            >
            Course
          </a>
          <span class="noLink" aria-label="Create a new Assignment - You do not have access to this page"
            *ngIf="!canShowMenu.hasMenuLearningAssessment">
            Course
          </span>
        </li>
        <li [ngClass]="{'inactiveMenuItem': !canShowMenu.hasMenuLearningAssessment}">
          <a uiSref="la-libraryManageRubricState"
            [uiParams]="{mode: RubricMode.Create}"
            [uiOptions]="{reload: true}"
            *ngIf="canShowMenu.hasMenuLearningAssessment"
            >
            Rubric
          </a>
          <span class="noLink" aria-label="Create a new Rubric - You do not have access to this page"
            *ngIf="!canShowMenu.hasMenuLearningAssessment">
            Rubric
          </span>
        </li>
        -->
      </ul>
    }
  </li>
</ul>
